import { TenantCatalog, TenantCatalogSidebar, SupervisorAreaLink } from '@vrbank/tenant-catalog-widget';

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }

  config.pluginSlots[slot_name].plugins.push(...plugins);
}

async function setConfig () {
  let config = {
    pluginSlots: {}
  };

  try {
    /* We can't assume FPF exists, as it's not declared as a dependency in all
     * MFEs, so we import it dynamically. In addition, for dynamic imports to
     * work with Webpack all of the code that actually uses the imported module
     * needs to be inside the `try{}` block.
     */
    const { DIRECT_PLUGIN, PLUGIN_OPERATIONS } = await import('@openedx/frontend-plugin-framework');
    if (process.env.APP_ID == 'admin-console') {
    }
    if (process.env.APP_ID == 'authn') {
    }
    if (process.env.APP_ID == 'authoring') {
    }
    if (process.env.APP_ID == 'account') {
    }
    if (process.env.APP_ID == 'communications') {
    }
    if (process.env.APP_ID == 'discussions') {
    }
    if (process.env.APP_ID == 'gradebook') {
    }
    if (process.env.APP_ID == 'learner-dashboard') {
      addPlugins(config, 'org.openedx.frontend.learner_dashboard.no_courses_view.v1', [
{
  op: PLUGIN_OPERATIONS.Hide,
  widgetId: 'default_contents',
},
{
  op: PLUGIN_OPERATIONS.Insert,
  widget: {
    id: 'tenant_catalog',
    type: DIRECT_PLUGIN,
    priority: 60,
    RenderWidget: TenantCatalog,
  },
}]);
      addPlugins(config, 'org.openedx.frontend.learner_dashboard.widget_sidebar.v1', [
{
  op: PLUGIN_OPERATIONS.Hide,
  widgetId: 'default_contents',
},
{
  op: PLUGIN_OPERATIONS.Insert,
  widget: {
    id: 'tenant_catalog_sidebar',
    type: DIRECT_PLUGIN,
    priority: 60,
    RenderWidget: TenantCatalogSidebar,
  },
}]);
      addPlugins(config, 'org.openedx.frontend.layout.header_desktop_secondary_menu.v1', [
{
  op: PLUGIN_OPERATIONS.Insert,
  widget: {
    id: 'supervisor_area_link_desktop',
    type: DIRECT_PLUGIN,
    priority: 60,
    RenderWidget: SupervisorAreaLink,
  },
}]);
      addPlugins(config, 'org.openedx.frontend.layout.header_mobile_main_menu.v1', [
{
  op: PLUGIN_OPERATIONS.Insert,
  widget: {
    id: 'supervisor_area_link_mobile',
    type: DIRECT_PLUGIN,
    priority: 60,
    RenderWidget: SupervisorAreaLink,
  },
}]);
    }
    if (process.env.APP_ID == 'learning') {
    }
    if (process.env.APP_ID == 'ora-grading') {
    }
    if (process.env.APP_ID == 'profile') {
    }
  } catch (err) { console.error("env.config.jsx failed to apply: ", err);}

  return config;
}

export default setConfig;